import { PageProps } from 'gatsby';
import { ReactNode } from 'react';
import { Header, Icon, Skeleton } from '@opswat/ui';
import { uuid } from '@opswat/ui/services';
import { PageHeader } from 'components/layout/PageHeader';
import { Logo } from 'components/layout/Logo';

type LoadingLayoutProps = Omit<PageProps, 'children'> & { children?: ReactNode };

export const LoadingLayout = ({ children }: LoadingLayoutProps) => {
    return (
        <div className='tw:font-roboto tw:flex tw:flex-col tw:h-screen' data-testid='loading-layout-root'>
            <Header>
                <Header.Collapse disabled />
                <Logo />
                <Header.Actions>
                    <PageHeader />
                </Header.Actions>
            </Header>
            <div className='tw:flex tw:overflow-hidden tw:h-full'>
                <div className='tw:flex tw:flex-col tw:justify-between tw:w-260 tw:max-md:w-160 tw:shrink-0 tw:border-r tw:border-neutrals-200 tw:dark:border-neutrals-1000'>
                    <div className='tw:flex tw:flex-col tw:gap-8 tw:p-8'>
                        {Array.from({ length: 25 }).map(() => (
                            <Skeleton key={uuid()} size='sm' />
                        ))}
                    </div>
                    <Icon iconName='tagline' className='tw:m-20 tw:w-188 tw:h-35' />
                </div>
                {/* `relative` — see the note on SidebarLayout.Content in Layout.tsx (MDCL-18164). */}
                <main className='tw:relative tw:p-12 tw:md:p-20 tw:bg-neutrals-100 tw:dark:bg-neutrals-1200 tw:flex-1 tw:min-w-0 tw:h-full tw:overflow-y-auto tw:border-l tw:border-neutrals-200 tw:dark:border-neutrals-1000'>
                    {children}
                </main>
            </div>
        </div>
    );
};
